import { IntegrationRoutes, PatientRoutes, routes, Routes } from 'routes';

export type Filter = string | ((url: string) => boolean);

const omitSideMenuRoutesImpact = new Set<string>([
  IntegrationRoutes.Prefix,
  IntegrationRoutes.IMPACT,
  IntegrationRoutes.IMPACT_LANDING,
  IntegrationRoutes.IMPACT_LANDING_SIGNIN,
  IntegrationRoutes.IMPACT_JOIN,
  IntegrationRoutes.IMPACT_PATIENT_IMPORT
]);

export const omitSideMenuRoutes = new Set<string>([
  ...omitSideMenuRoutesImpact,
  Routes.CreateAccountSuffix,
  Routes.PrivacyPolicy,
  Routes.TermsOfService,
  Routes.VerifyEmail,
  routes.onboarding.landing,
  routes.onboarding.registration
]);

export const omitSideMenuRoutesPatient = [
  ...omitSideMenuRoutes,
  PatientRoutes.PatientOnboardingProfile,
  PatientRoutes.PatientHowAreYouTracker,
  PatientRoutes.PatientPromis,
  PatientRoutes.Completion,
  PatientRoutes.CompletionPromis,
  PatientRoutes.PatientPcs,
  PatientRoutes.PatientDhi,
  PatientRoutes.PatientCgs,
  PatientRoutes.AssessmentResume,
  PatientRoutes.AssessmentStart,
  PatientRoutes.AssessmentControlFlow,
  PatientRoutes.ImpactAPI,
  PatientRoutes.Home
];

export const siteProgressBarRoutes: Filter[] = [
  (url: string) => url.includes(PatientRoutes.PatientPromis),
  (url: string) => url.includes(PatientRoutes.PatientPcs),
  (url: string) => url.includes(PatientRoutes.PatientDhi),
  (url: string) => url.includes(PatientRoutes.PatientCgs)
];

export const routesWithWhiteBg: Filter[] = [
  (url: string) => url.includes(PatientRoutes.Completion),
  (url: string) => url.includes(PatientRoutes.AssessmentResume),
  (url: string) => url.includes(PatientRoutes.PatientPromis),
  (url: string) => url.includes(PatientRoutes.CompletionPromis),
  (url: string) => url.includes(PatientRoutes.PatientPcs),
  (url: string) => url.includes(PatientRoutes.PatientDhi),
  (url: string) => url.includes(PatientRoutes.PatientCgs),
  (url: string) =>
    [
      PatientRoutes.AssessmentResume,
      PatientRoutes.AssessmentStart,
      PatientRoutes.AssessmentControlFlow
    ].some(_ => url.includes(_)),
  (url: string) => url.includes(PatientRoutes.ImpactAPI)
];

export const applyFilter = (url: string, filter: Filter[]) =>
  filter.findIndex(fn =>
    typeof fn === 'function' ? fn(url) : url.includes(fn)
  ) !== -1;
